import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Crown, ArrowLeft } from '@phosphor-icons/react';

const BusinessSuitePage = () => {
  const { user } = useAuth();
  const [iframeLoaded, setIframeLoaded] = useState(false);
  
  // Check if user has Inner Circle access
  const hasAccess = user?.role === 'paid_member' || user?.role === 'admin';

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#0a0a0a' }}>
        <div className="text-center p-8 max-w-md">
          <Crown size={64} weight="fill" className="mx-auto mb-6" style={{ color: '#c9a227' }} />
          <h1 className="text-2xl font-bold mb-4" style={{ color: '#fff' }}>Authentication Required</h1>
          <p className="mb-6" style={{ color: '#888' }}>Please log in to access the POWR Business Suite.</p>
          <Link 
            to="/login" 
            className="inline-block px-6 py-3 rounded-lg font-semibold"
            style={{ backgroundColor: '#c9a227', color: '#000' }}
          >
            Log In
          </Link>
        </div>
      </div>
    );
  }

  if (!hasAccess) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#0a0a0a' }}>
        <div className="text-center p-8 max-w-md">
          <Crown size={64} weight="fill" className="mx-auto mb-6" style={{ color: '#c9a227' }} />
          <h1 className="text-2xl font-bold mb-4" style={{ color: '#fff' }}>Inner Circle Exclusive</h1>
          <p className="mb-6" style={{ color: '#888' }}>
            The POWR Business Suite is an exclusive tool available only to Inner Circle members. 
            Upgrade your membership to unlock powerful business tools.
          </p>
          <Link 
            to="/inner-circle-sales" 
            className="inline-block px-6 py-3 rounded-lg font-semibold"
            style={{ backgroundColor: '#c9a227', color: '#000' }}
          >
            Join Inner Circle — $97/mo
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0a0a0a' }}>
      {/* Header */}
      <header 
        className="sticky top-0 z-50 px-6 py-4 flex items-center justify-between"
        style={{ backgroundColor: '#111', borderBottom: '1px solid #222' }}
      >
        <div className="flex items-center gap-4">
          <Link 
            to="/community" 
            className="flex items-center gap-2 text-sm hover:opacity-80 transition-opacity"
            style={{ color: '#c9a227' }}
          >
            <ArrowLeft size={18} />
            Back to Community
          </Link>
        </div>
        
        <div className="flex items-center gap-3">
          <Crown size={24} weight="fill" style={{ color: '#c9a227' }} />
          <span className="text-lg font-bold" style={{ color: '#fff', fontFamily: "'Playfair Display', serif" }}>
            POWR Business Suite
          </span>
          <span 
            className="px-2 py-1 text-xs font-bold rounded"
            style={{ backgroundColor: 'rgba(201, 162, 39, 0.2)', color: '#c9a227' }}
          >
            INNER CIRCLE
          </span>
        </div>

        <div className="w-32" /> {/* Spacer for centering */}
      </header>

      {/* Loading State */}
      {!iframeLoaded && (
        <div 
          className="flex items-center justify-center"
          style={{ height: 'calc(100vh - 65px)', backgroundColor: '#0a0a0a' }}
        >
          <div className="text-center">
            <div 
              className="w-12 h-12 border-4 border-t-transparent rounded-full animate-spin mx-auto mb-4"
              style={{ borderColor: '#c9a227', borderTopColor: 'transparent' }}
            />
            <p style={{ color: '#888' }}>Loading POWR Business Suite...</p>
          </div>
        </div>
      )}

      {/* Iframe */}
      <iframe
        src="https://kingdombs-rcptfx6l.manus.space/"
        title="POWR Business Suite"
        width="100%"
        style={{ 
          height: 'calc(100vh - 65px)',
          border: 'none',
          display: iframeLoaded ? 'block' : 'none'
        }}
        onLoad={() => setIframeLoaded(true)}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        data-testid="business-suite-iframe"
      />
    </div>
  );
};

export default BusinessSuitePage;
